import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

const ProtectedRoute = ({ children }) => {
  const { route, user } = useAuthenticator((context) => [context.route, context.user]);
  const location = useLocation();

  // 未認証の場合はサインインページへリダイレクト
  if (route !== 'authenticated' || !user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // 認証済みの場合は子コンポーネントを表示
  return children;
};

export default ProtectedRoute;
